import '../corejsImport';
//import 'regenerator-runtime/runtime';

import { getGlobal, EventEmitter, __FLIPIT_INTEGRATION__ } from '../helpers';
import { createComponent, integrate } from './bootstrap';

import { WINDOW_TYPE, EVENT } from '../constants'; 

const components = getGlobal().components = (getGlobal().components || {});

export {
    createComponent,
    integrate,
    components,
    EventEmitter,
    WINDOW_TYPE,
    EVENT,
    __FLIPIT_INTEGRATION__
};